import { render, staticRenderFns } from "./m_chinesebridge.vue?vue&type=template&id=2283e2ed&scoped=true"
import script from "./m_chinesebridge.vue?vue&type=script&lang=js"
export * from "./m_chinesebridge.vue?vue&type=script&lang=js"
import style0 from "./m_chinesebridge.vue?vue&type=style&index=0&id=2283e2ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2283e2ed",
  null
  
)

export default component.exports